module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "map"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f00ix-01.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('em', [_vm._v("Map of the Vilcabamba, the region in which Hiram Bingham searched for the last cities of the Incas between 1909 and 1915. (Map by Emily Davis Adams)")])]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f000x-01.gif"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fcaption"
  }, [_c('em', [_vm._v("South America, 1909, the scene of Hiram Bingham’s great successes and failures. (Map by Emily Davis Adams)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27019450","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780230337411_08_map.vue
// module id = 78
// module chunks = 0